// IMPORT REACT
import React from "react";
import Axios from "axios";

// IMPORT CONTAINERS
import Layout from '../../Layout';

// IMPORT COMPONENTS
import YAContainer from '../../../components/Grid/Container';
import YASection from '../../../components/Grid/Section';
import YARow from '../../../components/Grid/Row';
import YAColumn from '../../../components/Grid/Column';
import YAText from '../../../components/Text';
import YAButton from '../../../components/Form/Button';
import YAAccordian from '../../../components/Accordian';
import YACard from '../../../components/Accordian/Card';

// IMPORT STYLES
// import {} from '../../styles';

const Faqs = ({ lang, page, bloginfo }) => {
  return (
    <Layout lang={lang} page={page} bloginfo={bloginfo}
      header={
        <Header page={page} bloginfo={bloginfo} />
      }
      body={
        <div>
          <SectionMiddle page={page} />
        </div>
      }
    />
  );
}

const Header = ({ page, bloginfo }) => (
  <div>
    <YARow center>
      <YAColumn size="col-md-8 col-lg-6">
        <YAText tag="h1" bootstrap="display-4 mb-3">
          {page ? page.post_title : null}
        </YAText>
        <YAText tag="p" bootstrap="lead">
          {page ? page['meta']['page_section_0_text'] : null}
        </YAText>
      </YAColumn>
    </YARow>
  </div>
);

const FaqsCards = ({ page }) => {
  const faqsQuestions = Object.keys(page['meta']).filter(function (propertyName) {
    return propertyName.indexOf("faqs_section_1_question") === 0 && propertyName.indexOf("answer") === -1;
  });
  const faqsAnswers = Object.keys(page['meta']).filter(function (propertyName) {
    return propertyName.indexOf("faqs_section_1_question") === 0 && propertyName.indexOf("answer") > -1;
  });
  let faqsCombined = [];
  Object.keys(faqsQuestions).forEach(function(key, value) { 
    faqsCombined[faqsQuestions[key]] = faqsAnswers[key];
  });
  return (
      Object.keys(faqsCombined).map((key, index) => {
      return <YACard
        key={key}
        id={key}
        header={page ? page['meta'][key] : null}
        body={
          <YAText tag="span">
            {page ? page['meta'][faqsAnswers[index]] : null}
          </YAText>
        }
      />
    })
  );
}

const SectionMiddle = ({ page }) => (
  <YASection padding={{'top': '0'}}>
    <YAContainer>
      <YARow center>
        <YAColumn size="col-md-10 col-lg-8">
          <YAText tag="h2" addOn={
            <YAButton href={page ? page['meta']['faqs_section_1_button_link'] : null} 
              color="outline-primary"
            >
              {page ? page['meta']['faqs_section_1_button_text'] : null}
            </YAButton>
            }>
          </YAText>
        </YAColumn>
        <YAColumn size="col-md-10 col-lg-8">
          <YAAccordian>
            {page ? <FaqsCards page={page} /> : null}
          </YAAccordian>
        </YAColumn>
      </YARow>
    </YAContainer>
  </YASection>
);

export default Faqs;